import React from 'react';
import { toast } from 'react-toastify';
import { Box, Typography } from '@mui/material';
import { number, string } from 'prop-types';

import { InlineRoute, Toast } from '../../../../../../../../components';

const AutoSubscribeToast = ({ vehicleCount, route }) => {
  const message = `Subscribing ${vehicleCount} vehicles to a webhook.`;
  const type = 'info';
  const position = toast.POSITION.TOP_CENTER;
  const children = (
    <Typography variant="body2">
      <Box maxWidth="450px">
        <InlineRoute
          text={`This could take a few minutes. Go to the |+|Vehicles@@${route}|+| page to view the subscription status for each vehicle.`}
        />
      </Box>
    </Typography>
  );

  Toast(message, type, position, children);

  return null;
};

export default AutoSubscribeToast;

AutoSubscribeToast.propTypes = {
  vehicleCount: number.isRequired,
  route: string.isRequired,
};
